import styles from './mobile-header.module.css';

import AnimatedHamburger from './animated-hamburger';
import ThemeSwitcher from './theme-switcher';
import { Box, Flex } from '@radix-ui/themes';
import StoreProvider from '../store-provider';
import LogoContainer from '../logo/logo-container';
import { LOGO_HEIGHT } from '@/app/lib/constants/sizes';
import { ThemeMode, UserClient } from '@/app/lib/schemas/types/shared';
import AccountControls from './account-controls';

interface Props {
  isAtTop: boolean;
  user: UserClient | null;
  isClient: boolean;
  onSubscribe: () => void;
  onLogin: () => void;
  theme: ThemeMode;
  logoHeight: number;
  isAuthEnabled: boolean;
  isOpen: boolean;
}

const TabletHeader = ({
  isAtTop,
  user,
  onSubscribe,
  onLogin,
  isOpen,
  isClient,
  isAuthEnabled
}: Props) => {
  return (
    <Flex
      justify='between'
      className={`${styles.Panel} ${
        isAtTop && !isOpen ? styles.Top : styles.Scrolled
      }`}
    >
      <Box width='200px'>
        <Flex
          justify='start'
          align='center'
          gap='4'
        >
          <AnimatedHamburger />
          <StoreProvider>
            <LogoContainer logoHeight={LOGO_HEIGHT.header} />
          </StoreProvider>
        </Flex>
      </Box>
      <Flex
        justify='end'
        align='center'
        gap='4'
      >
        {isAuthEnabled && (
          <AccountControls
            user={user}
            onSubscribe={onSubscribe}
            onLogin={onLogin}
          />
        )}
        {isClient && <ThemeSwitcher />}
      </Flex>
    </Flex>
  );
};

export default TabletHeader;
